import { getCategoryForPostType, PostTypes } from '../Types';

const itemPermissions = (post: any, space: any): Record<string, any> => ({
  addToFolder: post?.permissions?.can_edit_post,
  assign: post?.permissions?.can_assign_post,
  destroy: post?.permissions?.can_delete_post,
  clone: post?.permissions?.can_clone_post,
  edit: post?.permissions?.can_edit_post,
  viewInDashboard: space?.permissions?.can_access_dashboard,
  newConsultation: post?.permissions?.can_create_consultations,
  newCommunication: post?.permissions?.can_create_communications,
  newFolder: post?.permissions?.can_create_folder,
  pinUnpin: post?.permissions?.can_pin_unpin,
  publishUnPublish: post?.permissions?.can_publish_unpublish,
  report: post?.permissions?.can_report,
  updateStatus: post?.permissions?.can_update_status,

  // Merge action is a status update
  merge: post?.permissions?.can_update_status,

  contactAuthor: post?.permissions?.can_contact_author,
});

const actionsPerPostCategory: Record<string, string[]> = {
  COMMUNICATION: ['addToFolder', 'clone', 'pinUnpin', 'publishUnPublish', 'edit', 'destroy'],
  CONSULTATION: [
    'addToFolder',
    'destroy',
    'edit',
    'pinUnpin',
    'clone',
    'publishUnPublish',
    'viewInDashboard',
  ],
  EVENT: [
    'addToFolder',
    'viewInDashboard',
    'pinUnpin',
    'publishUnPublish',
    'clone',
    'edit',
    'destroy',
  ],
  FOLDER: [
    'addToFolder',
    'edit',
    'newCommunication',
    'newConsultation',
    'newFolder',
    'clone',
    'publishUnPublish',
    'destroy',
    'viewInDashboard',
  ],
  PARTICIPATION: [
    'assign',
    'contactAuthor',
    'report',
    'edit',
    'destroy',
    'updateStatus',
    'merge',
    'viewInDashboard',
  ],
  MESSAGING: ['edit', 'updateStatus', 'destroy', 'assign', 'viewInDashboard'],
  STUDY: [
    'addToFolder',
    'pinUnpin',
    'viewInDashboard',
    'publishUnPublish',
    'edit',
    'clone',
    'destroy',
  ],
};

export default (post: any, space: any) => {
  let postCat;
  if (post.type === PostTypes.STUDY) {
    postCat = 'STUDY';
  } else if (post.type === PostTypes.EVENT) {
    postCat = 'EVENT';
  } else {
    postCat = getCategoryForPostType(post.type);
  }

  return actionsPerPostCategory[postCat].reduce((previous: any, current: any) => {
    return {
      ...previous,
      [current]: itemPermissions(post, space)[current],
    };
  }, {});
};
